import { makeStyles } from '@material-ui/core';
import { colorSet } from '@components/Provider';

export const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('md')]: {
      padding: '20px 16px',
      marginTop: '49px'
    }
  },
  item: {
    borderBottom: `1px solid ${colorSet.gray200}`,
    marginBottom: 20,
    paddingBottom: 20,
    '&.bottom': {
      borderBottom: `none`,
      display: 'flex',
      justifyContent: 'flex-end',
      '& button': {
        color: colorSet.gray600
      }
    }
  },
  myTitle: {
    ...theme.typography.h2,
    fontWeight: 500,
    color: colorSet.gray900,
    marginBottom: 36,
    [theme.breakpoints.down('md')]: {
      ...theme.typography.h3,
      fontWeight: 500
    }
  },
  companyTitleContainer: {
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start'
    }
  },
  companyTitle: {
    ...theme.typography.h2,
    fontWeight: 500,
    color: colorSet.gray900,
    marginBottom: 36,
    marginTop: 52,
    [theme.breakpoints.down('md')]: {
      ...theme.typography.h3,
      marginTop: 20,
      marginBottom: 36,
      fontWeight: 500
    }
  },
  bizTypeCaution: {
    ...theme.typography.caption,
    fontWeight: 400,
    color: colorSet.gray600,
    marginTop: 16,
    [theme.breakpoints.down('md')]: {
      marginTop: 0,
      marginBottom: 36
    }
  },
  span: {
    '&.primary': {
      color: colorSet.primary500
    },
    '&.textPrimary': {
      color: colorSet.gray900
    },
    '&.textSecondary': {
      color: colorSet.gray600
    },
    '&.bold': {
      fontWeight: 700 + `!important`
    },
    '&.semi-bold': {
      fontWeight: 400 + `!important`
    },
    '&.body2': {
      ...theme.typography.body2
    },
    '&.body1': {
      ...theme.typography.body1
    },
    '&.caption': {
      ...theme.typography.caption
    },
    '&.subtitle2': {
      ...theme.typography.subtitle2
    },
    '&.m-32': {
      marginBottom: 32
    }
  },
  divider: {
    margin: `20px 0`
  }
}));
